<template>
    <v-flex
        md12
        class="px-12 pb-12"
    >
        <PageHeader
            :breadcrumbs="breadcrumbs"
            :title="$t('page.learn_goal_control.title')"
            button
            :button-text="$t('page.learn_goal_control.new')"
            button-to="learn_goal_control_new"
            search
            :search-label="$t('page.learn_goal_control.search')"
            @search-input="searchInputListener"
        />
        <v-row>
            <ActionBar
                new-button
                new-to="learn_goal_control_new"
                :new-label="$t('page.learn_goal_control.new')"
                fetch
                :fetch-function="fetchData"
            />
            <v-col cols="12">
                <v-progress-linear
                    v-if="loading"
                    indeterminate
                    color="primary"
                />
                <v-skeleton-loader
                    v-if="loading"
                    class="mx-auto"
                    type="table-tbody"
                />
                <LearnGoalControlList
                    v-if="!loading"
                    :objects="objects"
                    :search="textSearch"
                />
            </v-col>
        </v-row>
    </v-flex>
</template>

<script>

import ActionBar from '@/components/common/ActionBar';
import PageHeader from '@/components/common/PageHeader';
import LearnGoalControlList from '@/components/learnGoalControl/LearnGoalControlList';
import LearnGoalControlProxy from '@/proxies/LearnGoalControlProxy';
import { SuccessSnackbar, ObjectDeleted } from '@/app-events.js';

export default {
    name: 'LearnGoalControlIndex',
    components: {
        ActionBar,
        PageHeader,
        LearnGoalControlList,
    },
    data() {
        return {
            breadcrumbs: [
                {
                    text: this.$t('page.home.title'),
                    exact: true,
                    to: { name: 'home' },
                },
                {
                    text: this.$t('page.learn_goal_control.title'),
                    disabled: true,
                },
            ],
            textSearch: '',
            objects: [],
            loading: true,
        };
    },
    created () {
        this.fetchData();
        this.$eventBus.listen(ObjectDeleted, (event) => {
            this.$eventBus.dispatch(new SuccessSnackbar(this.$t('learn_goal_control.actions.deleted')));
            for (let i = 0; i < this.objects.length; i++) {
                const learnGoalControl = this.objects[ i ];
                if (learnGoalControl.id === event.object.id) {
                    this.objects.splice(i, 1);
                    break;
                }
            }
        });
    },
    methods: {
        fetchData() {
            this.loading = true;
            new LearnGoalControlProxy().all().then(({ data }) => {
                this.objects = data.data;
                this.loading = false;
            }).catch(({ data }) => {
                this.displayError(data);
            });
        },
        searchInputListener(value) {
            this.textSearch = value;
        },
    },
};
</script>
